import { useNavigate } from 'react-router-dom';

import useAMRevamp from '~/hooks/useAMRevamp';
import useLocalStorage from '~/hooks/useLocalStorage';

import useAccount from './useAccount';

const useHostingNavigate = () => {
  const navigate = useNavigate();
  const { isAMRevamp } = useAMRevamp();
  const { id: hostingId } = useAccount();
  const [currentAMPage] = useLocalStorage('HOSTING_TYPE', 'HOSTING', true);
  return () => {
    if (!isAMRevamp) {
      navigate('/');
    } else if (currentAMPage === 'HOSTING') {
      navigate(hostingId ? `/package/websites?packageId=${hostingId}` : '/');
    } else if (currentAMPage === 'WEBSITE') {
      navigate('/sites');
    } else {
      navigate('/');
    }
  };
};

export default useHostingNavigate;
